import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { string } from 'prop-types'
import {
  Alert,
  Button,
  Divider,
  Heading,
  Icon,
  Input,
  Modal as TRModal,
  StackView,
  Text,
} from '@planningcenter/tapestry-react'
import { ThemeProvider } from './ThemeProvider'
import CopyButton from './CopyButton'

function Modal({ type, open, onRequestClose, uid, secret }) {
  return (
    <TRModal
      id="modal"
      style={{ width: '640px', maxWidth: '640px' }}
      height="auto"
      open={open}
    >
      <StackView spacing={2}>
        <Heading color="grey-9" weight={600} level={2} size={1}>
          {type} created
        </Heading>
        <Text size={3} style={{ lineHeight: '1.65' }}>
          Your new {type} is ready. Please copy the following two values and
          store them in a safe place.
        </Text>

        <StackView spacing={0.5}>
          <Input.InputLabel fontWeight={600}>Client ID:</Input.InputLabel>
          <StackView
            axis="horizontal"
            spacing={1}
            distribution="space-between"
            alignment="center"
          >
            <Input readonly value={uid} flex={1} />
            <CopyButton copyValue={uid} iconOnly={false} size="md" />
          </StackView>
        </StackView>

        <StackView spacing={0.5}>
          <Input.InputLabel fontWeight={600}>Secret:</Input.InputLabel>
          <StackView
            axis="horizontal"
            spacing={1}
            distribution="space-between"
            alignment="center"
          >
            <Input readonly value={secret} flex={1} />
            <CopyButton copyValue={secret} iconOnly={false} size="md" />
          </StackView>
        </StackView>

        <Alert type="error">
          <StackView
            axis="horizontal"
            spacing={1}
            alignment="center"
            padding={1}
          >
            <Icon name="general.exclamationTriangle" color="red-9" size="lg" />
            <Text size={3}>
              Your secret key will not be displayed again after closing this
              modal.
            </Text>
          </StackView>
        </Alert>

        <Divider marginTop={2} />
        <StackView
          axis="horizontal"
          distribution="end"
          marginVertical={1}
          spacing={1}
        >
          <Button
            title="Close"
            theme="interaction"
            variant="fill"
            size="lg"
            onClick={onRequestClose}
            fontWeight={500}
          />
        </StackView>
      </StackView>
    </TRModal>
  )
}

export default function NewApplicationAlert(props) {
  const [opened, setOpened] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (opened) return
    setOpen(true)
    setOpened(true)
  }, [open, opened])

  return (
    <React.Fragment>
      {createPortal(
        <ThemeProvider>
          <Modal open={open} {...props} onRequestClose={() => setOpen(false)} />
        </ThemeProvider>,
        document.body
      )}
    </React.Fragment>
  )
}

NewApplicationAlert.propTypes = {
  type: string.isRequired,
  uid: string.isRequired,
  secret: string.isRequired,
}
